import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Fab from '@material-ui/core/Fab';
import IconButton from '@material-ui/core/IconButton';

import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';

import FormContext from '../../common/form/FormContext';
import SubmitButton from './SubmitButton';

class EditButton extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            cancelPromise: undefined,
            open: false
        };
    }

    componentWillUnmount() {
        if (this.state.cancelPromise) {
            this.state.cancelPromise();
        }
    }

    handleClose(e) {
        if (!!e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.setState({open: false});
    }

    handleOpen(e) {
        if (!!e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.setState({open: true});
    }

    handleSubmit(e) {
        if (!!e) {
            e.preventDefault();
            e.stopPropagation();
        }

        return new Promise(resolve => {
            this.setState({cancelPromise: () => resolve()});
            this.props.onSubmit(this.props.data)
                .then(errors => {
                    if (!errors) {
                        this.handleClose();
                        resolve();
                    }
                });
        });
    }

    render() {
        const ButtonType = this.props.variant
            ? Button
            : this.props.type === 'add'
                ? Fab
                : IconButton;
        const contentClasses = classNames({
            'dialog-form': true,
            'fullscreen': this.props.fullScreen
        });
        return (
            <ButtonType
                className={this.props.className}
                disabled={this.props.disabled}
                disableTouchRipple={!this.props.variant && this.props.type !== 'add'}
                onClick={this.state.open ? null : this.handleOpen}
                size={this.props.type === 'add' ? 'small' : undefined}
                type="submit"
                variant={this.props.variant}
            >
                {do {
                    if (this.props.icon) {
                        this.props.icon;
                    } else if (this.props.type === 'add') {
                        <AddIcon/>;
                    } else if (this.props.type === 'edit') {
                        <EditIcon/>;
                    }
                }}
                {this.props.label}
                <Dialog
                    disableBackdropClick
                    fullScreen={this.props.fullScreen}
                    onClose={this.handleClose}
                    open={this.state.open}
                >
                    <DialogTitle>
                        {this.props.title}
                    </DialogTitle>
                    <DialogContent className={contentClasses}>
                        <FormContext.Provider value={{handleKeyDown: this.handleSubmit}}>
                            {this.props.getForm(this.props.data)}
                        </FormContext.Provider>
                    </DialogContent>
                    <DialogActions>
                        {do {
                            if (!!this.props.extraButtons) {
                                this.props.extraButtons;
                            }
                        }}
                        <SubmitButton
                            submitting={this.props.submitting}
                            onSubmit={this.handleSubmit}
                        />
                        <Button onClick={this.handleClose}>
                            <FormattedMessage id="buttons.cancel"/>
                        </Button>
                    </DialogActions>
                </Dialog>
            </ButtonType>
        );
    }
}

EditButton.propTypes = {
    data: PropTypes.object,
    disabled: PropTypes.bool,
    extraButtons: PropTypes.array,
    fullScreen: PropTypes.bool,
    getForm: PropTypes.func.isRequired,
    icon: PropTypes.object,
    label: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]),
    onSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    title: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]).isRequired,
    type: PropTypes.string
};

export default EditButton;


// WEBPACK FOOTER //
// ./src/components/common/button/EditButton.js